import { buildTranslate } from 'locales'
import { Fields as RedeemTemplate } from 'models/RedeemTemplate'
import React from 'react'
import Card from './Card'

type PropsT = {
  template: RedeemTemplate
}

const t = buildTranslate('redeem_manager.detail.cards.minimum_spend')

const MinimumSpendCard = ({ template }: PropsT) => {
  const hasMinimum =
    typeof template.minimum === 'number' && template.minimum > 0
  return (
    <Card title={t('title')} isActive={hasMinimum}>
      <p className="grey-70">
        {hasMinimum ? t('value', { amount: template.minimum }) : t('not_set')}
      </p>
    </Card>
  )
}

export default MinimumSpendCard
